import { useContext } from "react";

import type { Me } from "@/app/session/me";
import { SessionContext } from "@/app/session/SessionProvider";

export function useSession() {
  const context = useContext(SessionContext);
  if (context === null) {
    throw new Error("useSession must be used inside SessionProvider");
  }
  return context;
}

/** The signed-in person, or undefined when nobody is signed in. */
export function useSessionUser(): Me | undefined {
  const { state } = useSession();
  return state.status === "signed-in" ? state.user : undefined;
}

/** The signed-in person. Only call below RequireSession. */
export function useCurrentUser(): Me {
  const user = useSessionUser();
  if (user === undefined) {
    throw new Error("useCurrentUser called without a signed-in session");
  }
  return user;
}
